(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/parsers/parse-date-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/parsers/parse-date-picker.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function createDate(date) {
  if (!date) {
    return new Date();
  }
  if (date instanceof Date) {
    return date;
  }
  let utcDate;
  if (typeof date === 'string') {
    let time;
    let year = 0;
    let month = 0;
    let day = 0;
    let hours = 0;
    let minutes = 0;

    const _date$split = date.split('T'),
      _date$split2 = _slicedToArray(_date$split, 2),
      dateString = _date$split2[0],
      timeString = _date$split2[1];
    var _dateString$split = dateString.split('-');
    var _dateString$split2 = _slicedToArray(_dateString$split, 3);
    year = _dateString$split2[0];
    month = _dateString$split2[1];
    day = _dateString$split2[2];
    if (timeString) {
      var _timeString$split = timeString.split('+');
      var _timeString$split2 = _slicedToArray(_timeString$split, 1);
      time = _timeString$split2[0];
      var _time$split = time.split(':');
      var _time$split2 = _slicedToArray(_time$split, 2);
      hours = _time$split2[0];
      minutes = _time$split2[1];
    }
    utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
  }
  if (typeof date === 'object' && date.pick) {
    date = date.pick;
  }
  if (typeof date === 'number') {
    utcDate = new Date(date);
    const dateString = utcDate.toString();
    let _dateString$split3 = dateString.split('+'),
      _dateString$split4 = _slicedToArray(_dateString$split3, 2),
      timeZone = _dateString$split4[1];
    let timeZoneSign = 1;
    if (!timeZone) {
      var _dateString$split5 = dateString.split('-');
      var _dateString$split6 = _slicedToArray(_dateString$split5, 2);
      timeZone = _dateString$split6[1];
      timeZoneSign = -1;
    }

    const timeZoneOffset = parseInt(timeZone, 10) * timeZoneSign / 100;
    if (!isNaN(timeZoneOffset)) {
      utcDate.setHours(utcDate.getHours() + timeZoneOffset);
    }
  }
  return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
}
function parseDatesByMonth(_ref) {
  let resultDates = _ref.resultDates,
    month = _ref.month,
    year = _ref.year;
  if (Array.isArray(resultDates)) {
    const dates = [];
    resultDates.forEach(_ref2 => {
      let dateString = _ref2.date,
        drawNumber = _ref2.drawNumber,
        product = _ref2.product;
      const date = createDate(dateString);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      if (m === month && y === year) {
        dates.push({
          date: d,
          drawNumber,
          productDrawId: svs.numbergames.productMapping.getProductDrawId(product)
        });
      }
    });
    return dates;
  }
}
function addDates(datesArray) {
  if (Array.isArray(datesArray)) {
    const dates = {};
    datesArray.forEach(date => {
      dates[date.date] = date;
    });
    return dates;
  }
}
function addAddonDates(addonDates) {
  let datesMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Array.isArray(addonDates)) {
    addonDates.forEach(_ref3 => {
      let date = _ref3.date,
        drawNumber = _ref3.drawNumber,
        productDrawId = _ref3.productDrawId;
      const drawDate = datesMap[date];
      drawDate.addonDrawId = productDrawId;
      drawDate.addonDrawNumber = drawNumber;
    });
    return datesMap;
  }
}
function checkAddonDates(dates, addonDates, product) {
  if (dates && Array.isArray(addonDates)) {
    if (svs.numbergames.productMapping.isVikinglotto(product)) {
      const drawId = svs.numbergames.productMapping.getProductDrawId('ONSJOKER');
      addonDates = addonDates.filter(_ref4 => {
        let productDrawId = _ref4.productDrawId;
        return productDrawId === drawId;
      });
    }
    if (!addonDates.every(addonDate => Boolean(dates[addonDate.date]))) {
      svs.numbergames.results.logger.warn('Joker has been closed on other days than Lotto or Vikinglotto.');
      svs.numbergames.results.logger.debug('Want code that tries to handle it and move Joker to correct day?');
      svs.numbergames.results.logger.debug('Give your developers some cookies and we might just make it happen. ;)');
      addonDates = addonDates.filter(addonDate => Boolean(dates[addonDate.date]));
    }
    return addonDates;
  }
}
function parseDates(datePicker, addonDatePicker) {
  const dates = parseDatesByMonth(datePicker);
  let datesMap = addDates(dates);
  if (datesMap && addonDatePicker) {
    let addonDates = parseDatesByMonth(addonDatePicker);
    addonDates = checkAddonDates(datesMap, addonDates, datePicker.product);
    datesMap = addAddonDates(addonDates, datesMap);
  }
  return datesMap;
}
svs.numbergames.results.parsers.datePicker = {
  parseDates,
  createDate
};

 })(window);